import * as PlanningBottom from '../../../services/planningBottom.service';
import PlanningBottomType from './PlanningBottom.type';
import { toasterMsg } from '../../../Components/Toaster/Toaster';

export const getBottomData = (data) => async (dispatch) => {
  try {
    const res = await PlanningBottom.getBottomData(data);

    if (res.code === 200 && res.data) {
      await dispatch({
        type: PlanningBottomType.GETDATA,
        payload: { data: res.data, level: data?.level },
      });
    }
    return res.data;
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const SaveData = (data) => async () => {
  try {
    const res = await PlanningBottom.postSaveData(data);
    if (res.code === 200 && res.data) {
      return res;
    }
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const controlChannelModal = (state) => async (dispatch) => {
  try {
    await dispatch({
      type: PlanningBottomType.CHANNELINFO_MODAL,
      payload: state,
    });
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const editChannelInfo = (data) => async (dispatch) => {
  try {
    await dispatch({
      type: PlanningBottomType.EDIT_CHANNEL_DATA,
      payload: data,
    });
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const addChannel = (data, t) => async () => {
  try {
    const res = await PlanningBottom.addChannel(data);
    if (res.code === 200 && res.data) {
      return res.data;
    }
    toasterMsg(t(res.data.errMsg), 'danger');
    return 'err';
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const getChannelList = (data) => async (dispatch) => {
  try {
    const res = await PlanningBottom.getChannelList(data);
    if (res.code === 200 && res.data) {
      await dispatch({
        type: PlanningBottomType.GET_CHANNEL_LIST,
        payload: res.data,
      });
      return res.data;
    }
    toasterMsg(res.data.errMsg, 'danger');
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const editChannel = (data, t) => async () => {
  try {
    const res = await PlanningBottom.editChannel(data);
    if (res.code === 200 && res.data) {
      toasterMsg(t('BOM_LIBRARY_VIEW.SUPPORTING_DOCUMENT.CHANNEL_UPDATED_SUCCESSFULY'), 'success');
      return res.data;
    }
    toasterMsg(t(res.data.errMsg), 'danger');
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const setChannelSequence = (data) => async () => {
  try {
    const res = await PlanningBottom.setChannelSequence(data);
    if (res?.code === 200) {
      toasterMsg('Sequence Updated Successfully', 'success');
      return res;
    }
    toasterMsg(res.data.errMsg, 'danger');
  } catch (error) {
    toasterMsg(error.message, 'danger');
  }
};

export const deleteChannels = (deleteIds) => async () => {
  try {
    const res = await PlanningBottom.deleteChannelService(deleteIds);
    if (res?.code === 200) {
      toasterMsg('Channel Deleted Successfully', 'success');
      return res;
    }
    toasterMsg(res.data.errMsg, 'danger');

    return true;
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
    return false;
  }
};

export const loaderAction = (data) => async (dispatch) => {
  try {
    await dispatch({
      type: PlanningBottomType.LOADER,
      payload: data,
    });
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const getActiveChannelList = (data) => async (dispatch) => {
  try {
    const res = await PlanningBottom.getChannelList(data);
    if (res.code === 200 && res.data) {
      await dispatch({
        type: PlanningBottomType.GET_ACTIVE_CHANNEL_LIST,
        payload: res.data,
      });
      return res.data;
    }
    toasterMsg(res.data.errMsg, 'danger');
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const clearPlanningBottomData = () => async (dispatch) => {
  try {
    await dispatch({
      type: PlanningBottomType.CLEAR_PLANNING_BOTTOM_DATA,
    });
    return true;
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};
